export default __webpack_public_path__ + "static/media/bscScanMobile.12335a17.svg";